/**
 * Module front PUR (sans jQuery ni DOM) — règle de substitution de la commune de simulation pour
 * un logement étudiant, extraite à l'identique de `simulation.js::calculateEligible`.
 *
 * Note : contrairement à un premier constat d'audit, cette règle n'est PAS dupliquée dans
 * simulation_borne.js — la variante borne n'a pas de logique de logement étudiant du tout (elle
 * utilise `simulation_town` tel quel, sans substitution). Extraction motivée par la responsabilité
 * (règle métier sortie du fichier page), pas par une déduplication.
 *
 * Identifiants de commune codés en dur dans l'original, repris tels quels (pas corrigés).
 *
 * CommonJS (require/module.exports) pour être exécutable par Jest sans transpilation ; consommable par Webpack.
 */
'use strict';

/** @return {number} la commune à utiliser pour la simulation. */
function resolveSimulationStudentTown(logEtudiant, fallbackTown) {
    if (logEtudiant === 1) {
        return 109;
    }
    if (logEtudiant === 2) {
        return 98;
    }
    return fallbackTown;
}

module.exports = {
    resolveSimulationStudentTown: resolveSimulationStudentTown
};
